<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">塾</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark rounded depressed small color="error" @click.native="onCreate()">
                  <span class="text-none">新規</span>
                </v-btn>
              </v-toolbar>
            </v-col>
          </v-row>
          <v-sheet color="transparent">
            <v-row class="ma-0 px-4 py-0" align="center">
              <v-col cols="12" class="pa-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <v-col v-for="(header, index) in headers" :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                    <template v-if="header.valid">
                      <v-sheet class="pa-0 customHeader" color="transparent">
                        <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                        <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                      </v-sheet>
                    </template>
                    <template v-else>
                      <span>{{ header.title }}</span>
                    </template>
                  </v-col>
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto' :style="contentsHeight">
                  <RecycleScroller
                    class="scroller"
                    :items="filterItems"
                    :item-size="44"
                    key-field="key"
                  >
                    <template v-slot="{ item, index }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                          <v-col v-for="(header) in headers" :cols="header.width" class="pa-0" :align="header.align" @click.stop="onEdit(item)" :key="header.key">
                            <template v-if="header.key == 'number'">
                              <span class="overflow-text-hidden">{{ index + 1 }}</span>
                            </template>
                            <template v-if="header.key == 'name'">
                              <v-row class="ma-0 pa-0" align="center">
                                <v-col cols="2" class="pa-0">
                                  <v-avatar size="30">
                                    <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                    <v-avatar v-else size="30" color="primary"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                                  </v-avatar>
                                </v-col>
                                <v-col class="pa-0">
                                  <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                </v-col>
                              </v-row>
                            </template>
                            <template v-else-if="header.key == 'id'">
                              <tt>{{ item[header.key] }}</tt>
                              <v-btn icon small @click.stop.prevent="onClip(item)"><v-icon color="primary" small>mdi-content-copy</v-icon></v-btn>
                            </template>
                            <template v-else-if="header.key == 'createdAt'">
                              <span>{{ item[header.key] | moment }}</span>
                            </template>
                            <template v-else-if="header.key == 'ownerName'">
                              <v-chip small color="primary" depressed>
                                {{ item[header.key] }}
                              </v-chip>
                            </template>
                            <template v-else-if="header.key == 'enableType'">
                              <v-chip x-small :color="!item.enable ? 'error' : 'primary'"><span >{{ !item.enable ? '無効' : '有効' }}</span></v-chip>
                            </template>
                            <template v-else>
                              <span class="overflow-text-hidden"><tt>{{ item[header.key] }}</tt></span>
                            </template>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-col>

    <div class="text-center">
      <v-dialog
        v-model="dialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-school-dialog
          v-if="dialog"
          @dismissed="onDismissed"
          :item="selected"
          :type="type"
          :dialog='dialog'>
        </app-school-dialog>
      </v-dialog>
    </div>

    <v-snackbar
      v-model="snackbar"
      color="green"
      :timeout="3000"
      :top="true"
    >
      {{ '利用者登録IDをクリップボードにコピーしました' }}
      <v-btn rounded depressed x-small color="primary" @click.stop.prevent="snackbar = false">Close</v-btn>
    </v-snackbar>

  </v-row>
</template>

<script>
import Vue from 'vue'
import Clipboard from 'v-clipboard'
import moment from 'moment'
import { mapGetters } from 'vuex'
import SchoolDialog from '../../components/admin/SchoolDialog.vue'
Vue.component('app-school-dialog', SchoolDialog)
Vue.use(Clipboard)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      schools: 'schools/schools',
      windowSize: 'shared/windowSize'
    }),
    filterItems () {
      var temp = []
      for (var i in this.schools) {
        var item = JSON.parse(JSON.stringify(this.schools[i]))
        item['ownerName'] = this.getCharge(item)
        temp.push(item)
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 48 - 2 - 40) + 'px;'
    }
  },
  watch: {
    schools () {
      if (this.selected) {
        for (var i in this.schools) {
          if (this.schools[i].key === this.selected.key) {
            this.selected = JSON.parse(JSON.stringify(this.schools[i]))
          }
        }
      }
    }
  },
  data () {
    return {
      snackbar: false,
      dialog: false,
      type: null,
      headers: [
        { valid: false, over: false, value: 0, title: '#', key: 'number', width: '1', align: 'center' },
        { valid: true, over: false, value: 2, title: '名称', key: 'name', width: '3', align: 'start' },
        { valid: true, over: false, value: 0, title: 'KEY', key: 'key', width: '2', align: 'start' },
        { valid: false, over: false, value: 0, title: '利用者登録ID', key: 'id', width: '2', align: 'start' },
        { valid: true, over: false, value: 0, title: '作成日', key: 'createdAt', width: '2', align: 'start' },
        { valid: true, over: false, value: 0, title: '作成者', key: 'ownerName', width: '1', align: 'start' },
        { valid: false, over: false, value: 0, title: '状態', key: 'enableType', width: '1', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      selected: null,
      search: null
    }
  },
  created () {
    this.selected = JSON.parse(JSON.stringify(this.$store.getters['schools/initial']))
  },
  methods: {
    getNamePrefixFromItem (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getCharge (item) {
      const index = this.users.findIndex(user => user.key === item.owner)
      if (index !== -1) {
        return this.users[index].sei
      }
      return ''
    },
    onDismissed: function (value) {
      this.dialog = false
      if (this.deleteDialog) {
        this.deleteDialog = false
        if (value) {
          this.onDelete()
        }
      }
    },
    onClip (item) {
      this.$clipboard(item.id)
      this.snackbar = true
    },
    onCreate () {
      this.type = 'create'
      this.selected = JSON.parse(JSON.stringify(this.$store.getters['schools/initial']))
      for (var i = 0; i < 100; i++) {
        var id = this.getRandom()
        if (this.checkId(id)) {
          this.selected['id'] = id
          break
        }
      }
      if (this.selected['id'] === null) {
        return
      }
      // if (this.checkServer()) {
      //   this.selected['preschool'] = true
      //   this.selected['extension'] = 1
      // }
      this.dialog = true
    },
    checkId (id) {
      var check = true
      for (var i in this.schools) {
        if (this.schools[i].id === id) {
          check = false
          break
        }
      }
      return check
    },
    onEdit (item) {
      this.type = 'edit'
      this.selected = item
      this.dialog = true
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}
.customHeader {
  cursor: pointer;
  user-select: none;
}
.customLine {
  cursor: pointer;
  user-select: none;
}
.customLine:hover {
  background-color: #CCCCCC20;
}
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
